const productId = process.env.VUE_APP_PRODUCT_NAME;

export const getProductionName = () => {
  const productionMap = {
    zz: "ZZ",
    nb: "牛币",
    ml: "米乐",
    bb: "BB"
  };

  return productionMap[productId];
};

// 获取系统版本
export const getOsVersion = () => {
  let u = navigator.userAgent,
    version = "";
  // 如果mobile-detect获取不到设备名称，使用这个补充代替
  let deviceName = "";

  if (u.indexOf("Mac OS X") > -1) {
    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.159 Safari/537.36
    // ios
    let regStr_saf = /OS (X\s)?[\d._]*/gi;
    let verinfo = u.match(regStr_saf);
    version =
      "IOS" + (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
    deviceName = "Mac";
  } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    // android
    version =
      "Android" +
      u.substr(
        u.indexOf("Android") + 8,
        u.indexOf(";", u.indexOf("Android")) - u.indexOf("Android") - 8
      );
    deviceName = "Android";
  } else if (u.indexOf("BB10") > -1) {
    // 黑莓bb10系统
    version =
      "blackberry" +
      u.substr(
        u.indexOf("BB10") + 5,
        u.indexOf(";", u.indexOf("BB10")) - u.indexOf("BB10") - 5
      );
    deviceName = "blackberry";
  } else if (u.indexOf("IEMobile") > -1) {
    // windows phone
    version =
      "winphone" +
      u.substr(
        u.indexOf("IEMobile") + 9,
        u.indexOf(";", u.indexOf("IEMobile")) - u.indexOf("IEMobile") - 9
      );
    deviceName = "winphone";
  } else {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (
      userAgent.indexOf("windows nt 5.1") > -1 ||
      userAgent.indexOf("windows nt 5.2") > -1
    ) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (
      userAgent.indexOf("windows nt 6.1") > -1 ||
      userAgent.indexOf("windows 7") > -1
    ) {
      version = "Windows 7";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows 8") > -1
    ) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows nt 10.0") > -1
    ) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
    deviceName = version;
  }
  const res = version.match(/(.*?)([\d.]+)/) || [];
  const [, sysName, sysVersion] = res;
  return {
    sysName,
    sysVersion,
    deviceName
  };
};

export function getBrowser() {
  let UserAgent = navigator.userAgent.toLowerCase();
  let browserInfo = {};
  let browserArray = {
    IE: window.ActiveXObject || "ActiveXObject" in window, // IE
    Chrome:
      UserAgent.indexOf("chrome") > -1 && UserAgent.indexOf("safari") > -1, // Chrome浏览器
    Firefox: UserAgent.indexOf("firefox") > -1, // 火狐浏览器
    Opera: UserAgent.indexOf("opera") > -1, // Opera浏览器
    Safari:
      UserAgent.indexOf("safari") > -1 && UserAgent.indexOf("chrome") == -1, // safari浏览器
    Edge: UserAgent.indexOf("edge") > -1, // Edge浏览器
    QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
    WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
  };
  // console.log(browserArray)
  for (let i in browserArray) {
    if (browserArray[i]) {
      let versions = "";
      if (i == "IE") {
        versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
      } else if (i == "Chrome") {
        for (let mt in navigator.mimeTypes) {
          //检测是否是360浏览器(测试只有pc端的360才起作用)
          if (
            navigator.mimeTypes[mt]["type"] == "application/360softmgrplugin"
          ) {
            i = "360";
          }
        }
        versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
      } else if (i == "Firefox") {
        versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
      } else if (i == "Opera") {
        versions = UserAgent.match(/opera\/([\d.]+)/)[1];
      } else if (i == "Safari") {
        versions = UserAgent.match(/version\/([\d.]+)/)[1];
      } else if (i == "Edge") {
        versions = UserAgent.match(/edge\/([\d.]+)/)[1];
      } else if (i == "QQBrowser") {
        versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
      }
      browserInfo.type = i;
      browserInfo.versions = parseInt(versions);
    }
  }
  return browserInfo;
}
